import gql from 'graphql-tag';

const LOGIN_USER = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password)
  }
`;

const SIGNUP_USER = gql`
  mutation(
    $firstName: String
    $lastName: String
    $primaryEmail: String
    $companyName: String
    $phoneNumber: String
    $priCtryCode: String
    $deviceCount: Int
    $techCount: Int
  ) {
    signUpUser(
      input: {
        firstName: $firstName
        lastName: $lastName
        primaryEmail: $primaryEmail
        companyName: $companyName
        phoneNumber: $phoneNumber
        priCtryCode: $priCtryCode
        deviceCount: $deviceCount
        techCount: $techCount
      }
    ) {
      cid
    }
  }
`;

export { LOGIN_USER, SIGNUP_USER };
